import React from "react";
import { FlowerInside } from "./FlowerInside";
import Couronne from "./Couronne";

const Flower = React.memo(({ flowerRef, userAnswers }) => {
  return (
    <div ref={flowerRef}>
      <div className="container_fleur">
        <div className="content_fleur">
          <FlowerInside userAnswers={userAnswers} />
          <Couronne />
        </div>
      </div>
    </div>
  );
});

Flower.displayName = "Flower";

export default Flower;
